import React, {useEffect, useState, useContext} from 'react';
import {Route, Navigate, Routes, useLocation} from 'react-router-dom';
import { useNavigate, Outlet } from 'react-router-dom';
import {useDispatch, useSelector} from "react-redux";
import {getExpiration, getLoginScreenStatus, getUser} from '../../../helpers/index.js';
import TopNav from "../topNav/index.js";
import PageTracker from "../../pageTracker/index.js";
import FavIconLoader from "../../favIconLoader/index.js";
import { AppContext } from '../../../context/AppContext.js';
import jwt_decode from "jwt-decode";
import UnauthorizedError from "../Errors/UnauthorizedError";
import Breadcrumb from "../../breadcrumb/index.js";
import {externalPathToFilter} from "../../../context/externalPathToFilter.js";
import {AUTH_ERROR} from "../../../actions/types";
import ScrollTracker from "../../scrollTracker/index";
//const logoutFunc = logout(true)(navigate);

const PrivateRoute = ({ children }) => {
    const [errorMesssage, setErrorMessage] = useState(null);
    const user = getUser();
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    let tokenExpired = false;
    if (token) {
        try {
            tokenExpired = (jwt_decode(token).exp * 1000) < Date.now();
        } catch (e) {
            tokenExpired = true;
        }
    }
    const loginScreen = getLoginScreenStatus();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const [currentLocation, setCurrentLocation] = useState(location.pathname);
    const {logout} = React.useContext(AppContext);
    const logoutFunc = logout(true)(navigate);

    useEffect(() => {
        setCurrentLocation(location.pathname);
    }, [location])

    useEffect(async () => {
        debugger;
        debugger;
        if (!externalPathToFilter.includes(currentLocation.replace('/',''))) {
            if (!(user && token && !tokenExpired)) {
                await dispatch(logoutFunc);
            }
        }
    })

    return (
        (user && token && !tokenExpired) ?
            //<TopNav key={"topNav"}><PageTracker><FavIconLoader><Outlet/></FavIconLoader></PageTracker></TopNav> :
            [<TopNav key={"topNav"}/>, <PageTracker key={"pageTracker"}><Breadcrumb/><FavIconLoader><ScrollTracker onThresholdReached={() => {
                console.log('User read 50% of the content!');
            }}><Outlet/></ScrollTracker></FavIconLoader></PageTracker>] :
                loginScreen && !token && window.location.href.split(window.location.host + '/')[1].length > 0  ?
                    //<UnauthorizedError/> :
                    <Navigate to="/login" /> :
                    <Navigate to="/login" />

    )
}

export default PrivateRoute;
